import { IconButton, IconButtonProps } from '@chakra-ui/react';
import { forwardRef, ReactNode } from 'react';

/*
 * Same translation as `MButton` (see its own header comment) — `IconButton`
 * shares `Button`'s exact prop shape in v3 (`IconButtonProps extends
 * ButtonProps`), so it has the identical `isLoading`/`isDisabled` no-op gap.
 * Was a raw `export { IconButton as MIconButton } from '@chakra-ui/react'`
 * passthrough in `chakra.tsx` until now.
 *
 * v2's `IconButton` also took `icon` as its sole child; v3's real
 * `IconButton` is a thin `Button` wrapper (children only, confirmed via its
 * actual source), so `icon` was a silent no-op the same way `MButton`'s
 * `leftIcon` was — rendered as `children` instead.
 */
export interface MIconButtonProps extends IconButtonProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  icon?: ReactNode;
}

const MIconButton = forwardRef<HTMLButtonElement, MIconButtonProps>(
  (
    { isLoading, isDisabled, icon, loading, disabled, children, ...rest },
    ref,
  ) => (
    <IconButton
      ref={ref}
      loading={loading ?? isLoading}
      disabled={disabled ?? isDisabled}
      {...rest}
    >
      {icon ?? children}
    </IconButton>
  ),
);

MIconButton.displayName = 'MIconButton';

export default MIconButton;
